import { render } from "./SpinnerDotsShadow.vue?vue&type=template&id=790b6a3c&scoped=true"
import script from "./SpinnerDotsShadow.vue?vue&type=script&lang=js"
export * from "./SpinnerDotsShadow.vue?vue&type=script&lang=js"

import "./SpinnerDotsShadow.vue?vue&type=style&index=0&id=790b6a3c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790b6a3c"]])

export default __exports__